module.exports = __webpack_public_path__ + "static/media/Djibouti.8910b57b.png";